/**
  This file is to be removed when the icons have been converted to mdi in the production DB.
  This should be done no later than March 2020.

  Note: remove corresponding tests as well.
*/
const convertAdvisorNavIconsToMdi = (mdIconName) => {
  switch (mdIconName) {
    case 'dashboard': {
      return 'mdi-view-dashboard';
    }
    case 'people': {
      return 'mdi-account-multiple';
    }
    case 'pie_chart': {
      return 'mdi-chart-pie';
    }
    case 'monetization_on': {
      return 'mdi-currency-usd';
    }
    default: {
      return mdIconName;
    }
  }
};

export default {convertAdvisorNavIconsToMdi};
